=
<template>
    <div>
        <Card :padding="0">
            <div slot="title" class="card-title">
                <Icon type="map"></Icon>
                <span v-on:click="changeChart('Histogram')"
                      :class="chartClassify==='Histogram' ? 'choosed-title' :'unchoosed-title'">作业布置次数Top10教师 (可点击柱状图)</span>
                <span>|</span>
                <span v-on:click="changeChart('pieChart')"
                      :class="chartClassify==='pieChart' ? 'choosed-title' :'unchoosed-title'">学科类型和作业类型统计</span>
            </div>
            <a href="#" slot="extra" @click.prevent="changeLimit" v-if="chartClassify==='Histogram'">
                <Icon type="ios-loop-strong"></Icon>
                查看更多
            </a>
            <div style="height: 868px;">
                <div style="width:100%;height:100%;" id="data_sourceq" v-show="!isShow"
                     v-if="chartClassify==='Histogram'"></div>
                <div style="width:100%;height:100%;" id="data_sourceq-pie" v-show="!isShow" v-else></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    import {findTeaHomeWork, querySubjectMap, queryTypeOfWork} from "../../../service/api.js";

    export default {
        name: "tea-assign-homework",
        data () {
            return {
                chartClassify: "Histogram",
                startDate: "", //开始日期
                endDate: "", //结束日期
                isShow: false, //是否显示缺醒图
                schoolId: this.$route.query.schoolId, //学校ID
                schoolName: this.$route.query.schoolName, //学校ID
                useList: [], //教师集合
                subNameArr: [],//学科姓名集合
                subDataArr: [],//学科数据集合
                typeNameArr: [],//学段姓名集合
                typeDataArr: [],//学段数据集合
                pieDataSource: null,
                dataSource: null
            };
        },
        methods: {
            /**
             * 点击切换图表类型
             */
            changeChart (val) {
                let _this = this;
                _this.chartClassify = val;
                if (val === 'Histogram') {
                    //获取布置作业Top10教师数据
                    _this.getTeaHomeWork();
                    //清空饼状图的画布
                    _this.pieDataSource.clear();
                } else {
                    //获取作业学科使用饼图数据
                    _this.findSubjectMap();
                    //获取作业类型使用饼图数据
                    _this.findTypeOfWork();
                    //清空柱状图的画布
                    _this.dataSource.clear();
                    _this.$nextTick(() => {
                        setTimeout(function () {
                            //加载数据饼图
                            _this.initPieDataSource();
                        }, 300)
                    })
                }
            },
            /**
             * 查看更多数据
             */
            changeLimit (schoolId, startDate, endDate) {
                let routeData = this.$router.resolve({
                    name: "assHomeworkTea",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        parentalStartDate: this.startDate,
                        parentalEndDate: this.endDate
                    }
                });
                window.open(routeData.href, "_parent");
            },
            /**
             * 获取布置作业Top10教师数据
             */
            async getTeaHomeWork () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate
                };
                await findTeaHomeWork(params)
                    .then(function (data) {
                        _this.useList = data;
                        _this.initDataSource();
                        _this.isShow = _this.useList.length <= 0;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取作业学科使用饼图数据
             */
            async findSubjectMap () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startDate,
                    endTime: _this.endDate
                };
                await querySubjectMap(params)
                    .then(function (data) {
                        let homeworkSubjectData = data;
                        if (homeworkSubjectData.length > 0) {
                            _this.isShow = false;
                            _this.subDataArr = [];
                            _this.subNameArr = [];
                            for (let i = 0; i < homeworkSubjectData.length; i++) {
                                let obj = {};
                                obj.value = homeworkSubjectData[i].userCount;
                                obj.name = homeworkSubjectData[i].subName;
                                _this.subDataArr.push(obj);
                                _this.subNameArr.push(homeworkSubjectData[i].subName);
                            }
                        } else {
                            _this.isShow = true;
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取作业类型使用饼图数据
             */
            async findTypeOfWork () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startDate,
                    endTime: _this.endDate
                };
                await queryTypeOfWork(params)
                    .then(function (data) {
                        let homeworkTypeData = data;
                        if (homeworkTypeData.length > 0) {
                            _this.isShow = false;
                            _this.typeDataArr = [];
                            _this.typeNameArr = [];
                            for (let i = 0; i < homeworkTypeData.length; i++) {
                                let obj = {};
                                obj.value = homeworkTypeData[i].count;
                                obj.name = homeworkTypeData[i].name;
                                _this.typeDataArr.push(obj);
                                _this.typeNameArr.push(homeworkTypeData[i].name);
                            }
                        } else {
                            _this.isShow = true;
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 布置作业top10教师数据获取(柱状图)
             */
            initDataSource () {
                let _this = this;
                _this.dataSource = this.$echarts.init(
                    document.getElementById("data_sourceq")
                );
                let nameArr = [];
                let numArr = [];
                let displayName = "";
                for (let i = 0; i < this.useList.length; i++) {
                    displayName = this.useList[i].fullName;
                    nameArr.push(
                        displayName.length > 5
                            ? displayName.substring(0, 5) + "..."
                            : displayName
                    );
                    numArr.push(this.useList[i].num);
                }
                const option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                        },
                        //自定义悬浮框内容
                        formatter: function (params) {
                            var color = '#39C6E9';//图例颜色
                            var htmlStr = '<div>';
                            htmlStr += params[0].name + '<br/>';//x轴的名称
                            //添加圆点
                            htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
                            //添加一个汉字，格式化自定义文本内容
                            htmlStr += '布置' + '：' + params[0].value + '份';
                            htmlStr += '</div>';
                            return htmlStr;
                        }
                    },
                    xAxis: {
                        type: "category",
                        data: nameArr,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            formatter: '{value}次'
                        }
                    },
                    grid: {
                        left: 75
                    },
                    series: [
                        {
                            data: numArr,
                            type: "bar",
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true, //开启显示
                                        position: "top", //在上方显示
                                        textStyle: {
                                            //数值样式
                                            color: "black",
                                            fontSize: 12
                                        },
                                        formatter: function (params) {
                                            if (params.value > 1000) {
                                                let value = parseInt(params.value / 1000);
                                                return value + '千+';
                                            } else if (params.value > 10000) {
                                                let value = parseInt(params.value / 10000);
                                                return value + '万+';
                                            } else {
                                                return params.value;
                                            }
                                        }
                                    },
                                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#39C6E9"},
                                        {offset: 0.5, color: "#A3E5F5"},
                                        {offset: 1, color: "#A3E5F5"}
                                    ])
                                }
                            },
                            barGap: "-100%",
                            barCategoryGap: "40%"
                        }
                    ]
                };
                _this.dataSource.setOption(option);
                //柱状图点击事件
                _this.dataSource.on('click', function (params) {
                    if(_this.chartClassify==="Histogram"){
                        _this.$router.push({
                            name: "homeworkDetails",
                            query: {
                                schoolId: _this.schoolId,
                                schoolName: _this.schoolName,
                                selfStartDate: _this.startDate,
                                selfEndDate: _this.endDate,
                                teaId: _this.useList[params.dataIndex].teaId,
                                routerResource: -1
                            }
                        });
                    }
                });
                window.addEventListener("resize", function () {
                    _this.dataSource.resize();
                });
            },
            /**
             * 加载数据饼图（饼图）
             */
            initPieDataSource () {
                let _this = this;
                _this.pieDataSource = _this.$echarts.init(
                    document.getElementById("data_sourceq-pie")
                );
                const option = {
                    title: {
                        text: "学科类型和作业类型统计",
                        x: "center",
                        y:'15%'
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series: [
                        {
                            name: "学科类型",
                            type: "pie",
                            radius: "45%",
                            center: ["30%", "60%"],
                            data: _this.subDataArr,
                            color: ["#add8e6", "#ffb6c1","#00bfff", "#A0E7BC",'#FB8C8C',"#dda0dd"],
                            itemStyle: {
                                normal: {
                                    borderWidth: 2,
                                    borderColor: "#ffffff"
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)"
                                }
                            }
                        },
                        {
                            name: "作业类型",
                            type: "pie",
                            radius: "45%",
                            center: ["75%", "60%"],
                            color: [ "#add8e6", "#ffb6c1","#00bfff", "#A0E7BC",'#FB8C8C',"#dda0dd"],
                            data: _this.typeDataArr,
                            itemStyle: {
                                normal: {
                                    borderWidth: 2,
                                    borderColor: "#ffffff"
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)"
                                }
                            }
                        }
                    ]
                };
                _this.pieDataSource.setOption(option);
                window.addEventListener("resize", function () {
                    _this.pieDataSource.resize();
                });
            },
            //选择获取布置作业top10教师数据的开始时间与结束时间
            initDate (startDate, endDate) {
                this.startDate = startDate;
                this.endDate = endDate;
                this.changeChart("Histogram");
                // this.chartClassify="Histogram";
                // //选择完时间后重新请求接口
                // this.getTeaHomeWork();
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../style/common";

    .card-title {
        font-size: 14px;
        color: #17233d;
        font-weight: 700;
        cursor: pointer;
    }

    .choosed-title {
        color: #2b85e4;
        padding: 0 10px;
    }

    .unchoosed-title {
        padding: 0 10px;
    }
</style>
